import('./style.scss')
import ManagementLayout from './management-layout'

export default ManagementLayout
